import _ from 'lodash'
import moment from 'moment';
import React from 'react';
import $ from 'jquery';
import i18next from "i18next";
import {
    BetType,
    ClassicOddsResp,
    ClassicSportEvents,
    EventOrder,
    Market,
    MarketFilter,
    OddsFormat,
    OUTRIGHT_TYPE,
    Product,
    SportEventsUpdate,
    UserStatus,
    ViewKeys,
    PERIODS_DESC,
    GRADING_UNIT,
    GRADING_UNIT_TYPE,
    EventDetail,
    PAGETYPE,
    FullEvent,
    RUNNING_STATE_EXTRA_TIME,
    BetTypeGroup,
    VIEW,
    USER_TYPE,
    MOBILE_VIEWS,
    DEFAULT_DATES,
    RoundRobinOption,
    standardizeEventParamsMap,
    GROUP_SPORT_PERIODS,
    OddsFormatShortLabel,
    BROWSER_KEY,
    PRODUCT_CODE,
    ZENYTH_LOCALE_MAP,
    TeamType,
    BLOCKED_LEAGUE_NON_LOGIN,
    SPORT,
    SportMarketMap,
    ESportItemMap,
    SportItemMap,
    PeriodDetail,
    CATEGORY_PATH,
    STATEMENTS,
    VIP_TIER
} from "./Foundation"
import { LocalePath, LOCAL_STORAGE_KEY } from '../common/Foundation';
import Constants from './Constants';
import ToastGeneratorAction from '../components/BaseComponent/ToastGeneratorComponent/ToastGeneratorAction';
import AlertComponentAction from '../components/BaseComponent/AlertComponent/AlertComponentAction';
import StorageHelper from './StorageHelper';
import { matchPath } from 'react-router-dom';
import DirectusUtil from './directus/ultis';

const Fingerprint2 = require('fingerprintjs2');
const ArcadiaLocaleMap = {
  "en": "en_US",
  "de": "de_DE",
  "fr": "fr_FR",
  "zh-cn": "zh_CN",
  "zh-tw": "zh_TW",
  "id": "id_ID",
  "vi": "vi_VN",
  "ja": "ja_JP",
  "ko": "ko_KR",
  "th": "th_TH",
  "km": "km_KH",
  "es": "es_ES",
  "he": "he_IL",
  "pt": "pt_BR",
  "ru": "ru_RU",
  'tr': "tr_TR",
  "hi": "hi_IN",
  "hy": "hy_AM",
  "ka": "ka_GE",
  "uk": "uk_UA",
  "sv": "sv_SE"
  ,"fi": "fi_FI",
  "no": "nb_NO",
}
const dates = [];
export default class Utils {

    /**
     * Get footer content by current skin.
     * @returns { copyright: string, 
     *            copyrightNotice: string, 
     *            content: string,
     * }
     */
    static getFooterContent = () => {
        const TRANSLATION_KEYS = {
            pa: {
                FOOTER_COPYRIGHT: 'HOME_FOOTER_COPYRIGHT',
                FOOTER_COPYRIGHT_NOTICE: 'FOOTER_COPYRIGHT_NOTICE',
                FOOTER_CONTENT: 'HOME_FOOTER_CONTENT_PA',
                FOOTER_COSTA_RICA_LICENSE: 'FOOTER_COSTA_RICA_LICENSE',
            },
            vipinnacle: {
                FOOTER_COPYRIGHT: 'HOME_FOOTER_COPYRIGHT_VIPINNACLE',
                FOOTER_COPYRIGHT_NOTICE: 'FOOTER_COPYRIGHT_NOTICE_VIP',
                FOOTER_CONTENT: 'HOME_FOOTER_CONTENT_VIPINNACLE',
                FOOTER_COSTA_RICA_LICENSE: 'FOOTER_COSTA_RICA_LICENSE_VIP',
            }
        }
        const {
          FOOTER_COPYRIGHT,
          FOOTER_COPYRIGHT_NOTICE,
          FOOTER_CONTENT,
          FOOTER_COSTA_RICA_LICENSE
        } = TRANSLATION_KEYS[window.env.skinName];

        const currentYear = new Date().getFullYear();
        const enableLicenseCostaRica = _.get(window.env, "enableLicenseCostaRica", false);
        const footerCopyright = i18next.t(FOOTER_COPYRIGHT, {0: currentYear});
        const footerCopyrightNotice = i18next.t(FOOTER_COPYRIGHT_NOTICE);
        const footerContent = i18next.t(enableLicenseCostaRica
          ? FOOTER_COSTA_RICA_LICENSE
          : FOOTER_CONTENT);
          
        return {
          copyright: footerCopyright,
          copyrightNotice: footerCopyrightNotice,
          content: footerContent,
        }
     }
     

    /**
     * Generate odds id for oddspage.
     * @param {*} eventId 
     * @param {*} period
     * @param {*} betType 
     * @param {*} teamType 
     * @param {*} alt 
     * @param {*} spread 
     */
    static generateOddsId(eventId, period, betType, teamType, alt, spread) {
        let ids = [];
        ids.push(eventId, period, betType, teamType, alt, spread);
        return ids.join('|');
    }

    /**
     * This function use for convert stake string to number
     * @param {*} stake 
     */
    static convertStakeToNumber(stake) {
        if (stake) {
          stake = stake.toString().split(',').join('');
        }
        return !isNaN(stake) ? Number(stake) : 0;
      }
    
    /**
     * Generate Line Id for betslip.
     * @param {*} lineId 
     * @param {*} oddsId 
     * @param {*} teamType 
     */
    static generateLineId(lineId, oddsId, teamType) {
        let ids = [];
        ids.push(lineId, oddsId, teamType);
        return ids.join('|');
    }

    static getPeriodName(sportPeriods, sportId, periodNumber, isShortDesc) {
      const periodDecs = sportPeriods.find(period => period.sportId === parseInt(sportId, 10));
      const description = periodDecs ? periodDecs.periodsDescription.find(periodDec => periodDec[0] === parseInt(periodNumber, 10)) : [];
      return description ? (isShortDesc ? description[PERIODS_DESC.shortDescription] : description[PERIODS_DESC.description]) : '';
    }

    static formatCurrentScoreLive(inplayScore, betType){
        return inplayScore && (betType === BetType.THE_1X2 || betType === BetType.HANDICAP || betType === BetType.OU ) ? `[${inplayScore.replace(':','-')}]` : '';
    }
    
    static isEmpty(text) {
        try {
            if (text === null) {
                return true
            }
            switch (typeof text) {
                case 'string':
                    return text.trim() === ''
                case 'number':
                case 'boolean':
                case 'function':
                    return true
                case 'object':
                    return JSON.stringify(text) === JSON.stringify({})
                case 'undefined':
                default:
                    return true
            }
        } catch (e) {
            // console.log(e)
            return true
        }

    }

    static decodeBase64(text) {
        try {
            if (this.isEmpty(text)) {
                // console.log("Error argument empty!")
                return ""
            }
            return atob(text)
        } catch (e) {
            // console.log("Error Basecode64:", e)
            return ""
        }
    }

    static convertStringToJSON(text) {
        try {
            if (_.isEmpty(text)) return {};
            return JSON.parse(text)
        } catch (e) {
            // console.log("Error JSON:", e)
            return {}
        }
    }

    static generateUUID() {
        function generate() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return generate() + generate() + '-' + generate() + '-' + generate() + '-' +
            generate() + '-' + generate() + generate() + generate();
    };

    static generateDates(days, tz) {
        if (dates.length == 0) {
            days = days + 1;
            let today = tz ? moment().utcOffset(tz) : moment();

            for (var day = 1; day < days; day++) {
                dates.push({
                    value: today.add(1, 'days').format("YYYY-MM-DD"),
                    str: today.format("MM/DD")
                });
            }
            return dates;
        } else {
            return dates;
        }
    }
    static getDateRanges(numberOfDates = 5, timeZoneOffset = -240) {
        const generateDates = Utils.generateDates(numberOfDates, timeZoneOffset);
        let priority = 0;
        const dates = _.concat(DEFAULT_DATES,
            _.map(generateDates, (date, index) => {
              const { value } = date;
              return {
                text: value,
                value: value,
                priority: priority += 1
              };
            })
          );
        return _.orderBy(dates, ['priority']);
    }
    static generateTodayDates(tz) {
        let today = tz ? moment().utcOffset(tz) : moment();
        return {
            value: today.format("YYYY-MM-DD"),
            str: today.format("MM/DD")
        };
    }

    static generateDate(time, tz, translate) {
        let today = new Date();
        const defaultLocale = 'en_US';
        let aDate = new Date(time + today.getTimezoneOffset() * 60000 + tz * 60000);
        return {
            value: moment(aDate).format("YYYY-MM-DD"),
            str: moment(aDate).locale(defaultLocale).format("MM/DD")
        };
    }

    static toFirstCharacterUpperCase(text) {
        if (_.isEmpty(text)) return ''
        return text.charAt(0).toUpperCase() + text.slice(1)
    }

    static formatBalance(balance) {
        try {
            switch (typeof balance) {
                case 'number':
                    return balance.toDollar(2, true)
                case 'string':
                    return Number.parseFloat(balance).toDollar(2, true)
                default:
                    return balance
            }
        } catch (e) {
            // console.log('Error formatting number:', balance)
            return balance
        }
    }

    /**
     * Get leagueId based on param: leagueName-leagueID.
     */
    static getLeagueIdBasedOnURL = (leagueName) => {
        let arrLg = leagueName.split('-');
        return arrLg[arrLg.length - 1];
    }

    /**
     * Convert Mobx Object to Json Object
     */
    static convertMobxObjToJsonObj(mobxObject) {
        try {
            return JSON.parse(JSON.stringify(mobxObject))
        } catch (error) { }
    }

    /**
     * Get market filter by market display type
     */
    static castToMarketFilter = (marketDisplayType) => {
        switch (marketDisplayType) {
            case "ALL":
                return MarketFilter.All
            case "_1LINE":
                return MarketFilter._1Line
            case "_3LINES":
                return MarketFilter._3Lines
            case "_5LINES":
                return MarketFilter._5Lines
            default:
                return MarketFilter.Error
        }
    }

    /**
     * Update storage by key and value
     */
    static updateStorage = (key, value) => {
        const item = localStorage.getItem(key);
        const updatedItem = _.isEmpty(item) ? {} : Utils.convertStringToJSON(atob(item));
        Object.assign(updatedItem, value);
        localStorage.setItem(key, btoa(JSON.stringify(updatedItem)));
    }

    /**
     * Simulate Object.values (for IE 11)
     */
    static getObjectValues(obj) {
        return Object.keys(obj).map(function (e) {
            return obj[e]
        })

    }

    static fingerPrint = () => {
        var fpResult = "";
        var option = {
            excludeUserAgent: true,
            excludeLanguage: false,
            excludeColorDepth: false,
            excludeScreenResolution: false,
            detectScreenOrientation: true,
            excludeTimezoneOffset: false,
            excludeSessionStorage: false,
            excludeIndexedDB: true,
            excludeAddBehavior: false,
            excludeOpenDatabase: true,
            excludeCpuClass: true, // ie
            excludePlatform: false,
            excludeDoNotTrack: true, // ff
            excludeCanvas: true,
            excludeWebGL: true,
            excludeAdBlock: true,
            excludeHasLiedLanguages: false,
            excludeHasLiedResolution: false,
            excludeHasLiedOs: false,
            excludeHasLiedBrowser: false,
            excludeJsFonts: true,
            excludeFlashFonts: false,
            excludePlugins: true,
            excludeTouchSupport: true
        };
        var fp = new Fingerprint2(option);
        fp.get(function (result) {
            fpResult = result;
        });
        return fpResult;
    }

    static mapLangCountryCode = () => {
        if (!window.env) {
            return _.invert(LocalePath);
        }
        return (window.env.langSupports || []).reduce((acc, lang) => {
            const isNoSplit = ['zh_TW', 'zh_CN'].includes(lang);
            return {...acc, [
                isNoSplit 
                    ? lang.toLowerCase().replace('_', '-') 
                    : Constants.LOCALE_PATH_MAPPING[lang.trim()] || lang.split('_')[0]
                ] : lang
            };
        }, {});
    }

    static localeCodeToLanguageCode = (localeCode) => {
        let language = null;
        if (localeCode !== 'undefined' && localeCode != null) {
            language = _.invert(Utils.mapLangCountryCode())[localeCode];
        }
        return (language != null) ? language : 'en';
    }

    static toLocaleCode = (lng, noDefaultValue) => {
        let locale = null;
        if (lng !== 'undefined' && lng != null) {
            locale = Utils.mapLangCountryCode()[lng.toLowerCase()];
        }
        return (locale !== null || noDefaultValue) ? locale : 'en_US';
    }
    static getSubDomain = () => {
        let parts = document.domain.split('.');
        let domain = document.domain;
        if (parts.length > 2 && isNaN(parts[0])) {
            parts.splice(0, parts.length - 2);
            domain = "." + parts.join(".");
        }
        return domain
    }

    static getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
        let regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
        let results = regex.exec(window.location.search)
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    static setCookieDomain() {
        let __udata = JSON.parse(window.atob(localStorage.getItem('__udata'))) || null
        if (__udata === null) {
            return
        }
        if (__udata.auth && !localStorage.getItem('defaultView')) {
            localStorage.setItem('defaultView', 1)
            return;
        }
        let afRefCode = this.getParameterByName("a")
        let afTtId = this.getParameterByName("ttid")
        // if (afRefCode) {
        if (afRefCode !== "" && !StorageHelper.getBrowsersStorage(BROWSER_KEY.AFRC)) {
            StorageHelper.saveBrowsersStorage(BROWSER_KEY.AFRC, afRefCode, { expires: window.env.afrcExpriseTime });
        }
        if (afTtId !== "" && !isNaN(afTtId) && afTtId === window.parseInt(afTtId)) {
            StorageHelper.saveBrowsersStorage(BROWSER_KEY.AFTIID, afTtId)
        } else {
            afTtId = 0;
            StorageHelper.getBrowsersStorage(BROWSER_KEY.AFTIID);
            
        }
        // }
    }

    static getRealIP(__udata, response) {
        let headers = response.headers
        return headers.hasOwnProperty('x-real-ip') ? headers['x-real-ip'] : __udata.userIp
    }

    /**
     * Based on cache version to determine odds is getting or updating.
     * @param {*} data 
     * @param {*} index 
     */
    static cacheVersionData(data, index) {
        var v = '0';
        for (var i = 0; i < data.length; i++) {
            if (data.length === 1) {
                v = data[i][index];
            } else {
                if (i !== 0 && i === data.length - 1)
                    v += data[i][index];
                else
                    v += data[i][index] + ',';
            }
        }
        return v;
    }

    /**
     * Get current cache version.
     */
    static getCacheVersion() {
        let cacheVersion;
        if (!localStorage.getItem('_version')) {
            localStorage.setItem('_version', [0, 0]);
        }
        cacheVersion = localStorage.getItem('_version');
        return cacheVersion.split(',');
    }

    /**
     * Set current cache version.
     */
    static setCacheVersion(version) {
        return localStorage.setItem('_version', version);
    }

    /**
     * Reset cache version.
     */
    static resetCacheVersion() {
        localStorage.setItem('_version', [0, 0]);
    }

    /**
     * Get Classic View current cache version.
     */
    static getClassicViewCacheVersion() {
        let cacheVersion;
        if (!localStorage.getItem('classic_version')) {
            this.resetClassicViewCacheVersion()
            cacheVersion = [0, 0];
        } else {
            cacheVersion = localStorage.getItem('classic_version');
        }
        return JSON.parse(cacheVersion);
    }

    static extractClassicViewVersions(sportsData, versionIndex) {
        let versions = []

        if (sportsData) {
            sportsData.forEach(sportData => {
                versions.push(sportData[versionIndex])
            })
        }
        return versions.length > 0 ? versions.join(',') : '0'
    }

    /**
     * Set Classic View current  cache version.
     */
    static setClassicViewCacheVersion(data) {
        let _version = this.getClassicViewCacheVersion();
        if (data[ClassicOddsResp.liveEvent] || (data[ClassicOddsResp.liveUpdate] && data[ClassicOddsResp.liveUpdate][1].length > 0)) {
            if (data[ClassicOddsResp.liveEvent]) {
                _version[0] = this.cacheVersionData([data[ClassicOddsResp.liveEvent]], ClassicSportEvents.version);
            } else if (data[ClassicOddsResp.liveUpdate] && data[ClassicOddsResp.liveUpdate][1].length > 0) {
                _version[0] = this.cacheVersionData([data[ClassicOddsResp.liveUpdate]], SportEventsUpdate.version);
            }
        }
        if (data[ClassicOddsResp.normalEvent] || (data[ClassicOddsResp.update] && data[ClassicOddsResp.update][1].length > 0)) {
            if (data[ClassicOddsResp.normalEvent]) {
                _version[1] = this.cacheVersionData([data[ClassicOddsResp.normalEvent]], ClassicSportEvents.version);
            } else if (data[ClassicOddsResp.update] && data[ClassicOddsResp.update][1].length > 0) {
                _version[1] = this.cacheVersionData([data[ClassicOddsResp.update]], SportEventsUpdate.version);
            }
        }
        return localStorage.setItem('classic_version', JSON.stringify(_version));
    }

    /**
     * Reset Classic View cache version.
     */
    static resetClassicViewCacheVersion() {
        localStorage.setItem('classic_version', JSON.stringify([0, 0]));
    }

    /**
     * Detect view asia or euro or classic base on URL
     */
    static getViewByURLPath () {
        let viewOnURL = this.getViewPathByURLPath();
        if (viewOnURL === 'classic') {
            return 'classicView';
        }
        if (viewOnURL === 'asian') {
            return 'asiaView';
        }
        return 'euroView';
    }

    static getViewPathByURLPath () {
        let strUrl = window.location.href.replace(window.APP_ROUTER_BASE, "");
        let pathArray = strUrl.split("/");
        let viewPathOnURL = '';
        //// console.log("pathArray", pathArray);
        if (pathArray.length > 3) {
            let params = pathArray[4] ? pathArray[4].split('?') : null;
            viewPathOnURL = params && params.length > 0 ? params[0] : pathArray[4];

        }
        return viewPathOnURL;
    }

    static getCurrentView () {
        let viewPathByURLPath = Utils.getViewPathByURLPath();
        return (viewPathByURLPath == 'asian' || viewPathByURLPath == 'classic') ? viewPathByURLPath : '';
    }

    static getCurrentSkin() {
        return StorageHelper.getBrowsersStorage(BROWSER_KEY.SKIN) || window.env.skinName;
    }

    static getCurrentLang() {
        return sessionStorage.getItem('lng') || 'en'
    }

    static getCurrentLocaleCode() {
        return Utils.toLocaleCode(Utils.getCurrentLang())
    }

    static getLangForStaticUrl() {
        return _.invert(LocalePath)[this.getCurrentLang()].toLowerCase().replace("_", "-")
    }
    
    /**
     * Check is pa skin
     */

    static isPA() {
        return window.env.skinName === 'pa';
    };

    static isWLCash() {
        return ['pa', 'vipinnacle'].includes(window.env.skinName)
    };

    static isVIPinnacle() {
        return window.env.skinName === 'vipinnacle';
    }

    /**
       * Check isAbsoluteURL
       */
    static isAbsoluteURL(url) {
        var r = new RegExp('^(?:[a-z]+:)?//', 'i');
        return r.test(url);
    }

    static getResultsURL(date, sp, lg) {

        let url = '/' + this.getCurrentLang() + '/results/';
        if (date && sp && lg) {
            url += date + '/' + sp + '/' + lg;
        } else if (date) {
            url += date + '/sports';
        }
        return url;
    }

    static triggerOnchangeInput(input, value) {
        if (value) {
            var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
            nativeInputValueSetter.call(input, value);
            var event = new Event('input', { bubbles: true });
            input.dispatchEvent(event);
        }
    }

    static showToastAddingBet(selectionId, selectedName, odds, tapOnLinkAction, isTeaser) {
        let message = [
            Constants.TOAST.ADDING_BET_MESSAGE,
            `${selectedName} @ <span class=${!isTeaser && odds < 0 ? 'neg' : ''}>${odds}</span>`
        ];
        ToastGeneratorAction.generateAddingSelectionToast(selectionId, message, Constants.TOAST.TOAST_CLASS_ACTIVE, tapOnLinkAction);
    }

    static showToastError() {
        const message = [
            Constants.TOAST.ERROR_MESSAGES
        ];
        ToastGeneratorAction.generateToast({messages: message, className: Constants.TOAST.TOAST_CLASS_ERROR});
    }

    static generateOddsPageURL(sportName, market, leagueId, leagueName, eventId, eventName) {
        let paths = [sportName, market, leagueId, leagueName]
        if (eventId) {
            paths.push(eventId, eventName)
        }
        return paths.join('/')
    }


    static formatOddsValue = (price, oddsFormat) => {
        let newFormat = '';
        if (!price) {
            return newFormat;
        }
        const convertedPrice = parseFloat(price.toString().replaceAll(',', ''));
        if (convertedPrice) {
            if (OddsFormat.AM === Number(oddsFormat)) {
                newFormat = (convertedPrice > 0 ? '+' : '') + convertedPrice.toFixed(0);
            } else {
                newFormat = convertedPrice.toDollar(3, true)
            }
        }
        return newFormat;
    }

    static formatHandicapNumber(betType, handicap, propsLabel) {
        const isInValidType = typeof (handicap) === 'string' || typeof (handicap) === 'undefined' || handicap === null;
        if (isInValidType || this.isHiddenHandicap(propsLabel)) {
            return '';
        }
        // do not show hdp point if betType is outright and hdp point is 0
        if ((betType === BetType.OUTRIGHT || betType === BetType.SPECIALS || betType === BetType.THE_1X2) && handicap === 0) {
            return '';
        }

        if (betType !== BetType.OUTRIGHT
            && betType !== BetType.SPECIALS
            && betType !== BetType.OU
            && betType !== BetType.HOME_TOTALS
            && betType !== BetType.AWAY_TOTALS
            ) {
            if ( handicap > 0) {
                return `+${handicap}`;
            } else if ( handicap < 0 ) {
                return handicap
            } else {
                return handicap.toDollar(1, true)
            }
        }
        return handicap;
    }
    static getUserLanguage() {
        const udata = this.getUdata();
        if (udata.auth) {
            return Object.keys(this.mapLangCountryCode())
                .filter(key => this.mapLangCountryCode()[key] === udata.locale)
                .reduce((lang, key) => {
                    lang = key;
                    return lang;
                }, this.getCurrentLang());
        }
        return this.getCurrentLang();
    }

    static changeLocaleInUdata(locale) {
        let udata = JSON.parse(window.atob(localStorage.getItem('__udata')));
        udata.locale = locale;
        localStorage.setItem('__udata', window.btoa(JSON.stringify(udata)))
    }

    static getGameNameByLeagueName(leagueName) {
        const nameList = leagueName ? leagueName.split('-') : '';
        return nameList.length > 1 ? _.first(nameList).toLowerCase().trim() : 'Other';
    }

    static getGameCodeByLeagueName(leagueName) {
        return this.getGameNameByLeagueName(leagueName).replaceAll(':', '').replaceAll(' ', '');
    }

    static getUdata() {
        try {
            return JSON.parse(window.atob(localStorage.getItem('__udata'))) || {};
        } catch (e) {
            return {};
        }
    }
    static formatGameCode(gameCode) {
      return gameCode === 'cs2' ? 'csgo' : gameCode.replace(/ /g, '').replace(/:/g, '');
    }
    
    static getEsportsImage(gameCode, leagueId) {
      const gCode = Utils.formatGameCode(gameCode)
      const esportsLogoVersion = _.get(Utils.getUdata(), 'esportsLogoVersion', '');
      const logoURL = window.env.esportsImageCdnEnabled
        ? window.env.esportsLogoURL.replace('{version}', esportsLogoVersion)
        : Constants.ESPORTS_LOGO_URL

      if (leagueId) {
          return window.env.esportsImageCdnEnabled
            ? logoURL.concat(gCode, '/league/', leagueId, '.png')
            : ''
      }
      return logoURL.includes(esportsLogoVersion)
        ? logoURL.concat(gCode, '/game/', gCode, '.png')
        : logoURL.concat('games/', gCode, '.png')
    }

    static convertEventSorting(order) {
        let eventOrder

        if (isNaN(order)) {
            switch (order.toLowerCase()) {
                case 'time':
                    eventOrder = EventOrder.Time
                    break

                case 'league':
                    eventOrder = EventOrder.League
                    break

                default:
                    eventOrder = EventOrder.Time
            }
        } else {
            eventOrder = order
        }

        return eventOrder
    }

    static getVSSelectionName = (selection, translate) => {
        let selectionName = ''
        switch (selection) {
            case '1st':
                selectionName = translate('Q1')
                break;
            case '2nd':
                selectionName = translate('Q2')
                break;
            case '3rd':
                selectionName = translate('Q3')
                break;
            case '4th':
                selectionName = translate('Q4')
                break;
            default:
                selectionName = _.startCase(selection)
                break;
        }

        return selectionName
    }

    static getAllUrlParams = (url, isLowerCase = true) => {
		// get query string from url (optional) or window
		let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

		// we'll store the parameters here
		let obj = {};

		// if query string exists
		if (queryString) {

			// stuff after # is not part of query string, so get rid of it
			queryString = queryString.split('#')[0];

			// split our query string into its component parts
			let arr = queryString.split('&');

			for (let i = 0; i < arr.length; i++) {
				// separate the keys and the values
				let a = arr[i].split('=');

				// in case params look like: list[]=thing1&list[]=thing2
				let paramNum = undefined;
				let paramName = a[0].replace(/\[\d*\]/, function (v) {
					paramNum = v.slice(1, -1);
					return '';
				});

				// set parameter value (use 'true' if empty)
				let paramValue = typeof (a[1]) === 'undefined' ? 'true' : a[1];

				// (optional) keep case consistent
                if (isLowerCase) {
                    paramName = paramName.toLowerCase();
                    paramValue = paramValue.toLowerCase();
                }

				// if parameter name already exists
				if (obj[paramName]) {
					// convert value to array (if still string)
					if (typeof obj[paramName] === 'string') {
						obj[paramName] = [obj[paramName]];
					}
					// if no array index number specified...
					if (typeof paramNum === 'undefined') {
						// put the value on the end of the array
						obj[paramName].push(paramValue);
					}
					// if array index number specified...
					else {
						// put the value at that index number
						obj[paramName][paramNum] = paramValue;
					}
				}
				// if param name doesn't exist yet, set it
				else {
					obj[paramName] = paramValue;
				}
			}
		}

		return obj;
    }
    
    static setShowTCPageST = (isShowTCPage) => {
      let prefs = { showTC: isShowTCPage };
      sessionStorage.setItem("prefs", JSON.stringify(prefs));
    }

    static utcDateFormat = (date, format, timeZone) => {
      const utcOffset = timeZone ? timeZone : "GMT-04:00";
      const formatString = format ? format : "DD/MM/YYYY HH:mm:ss";
      return moment(date).utcOffset(utcOffset).format(formatString);
    }

    static currentUTCDate = (timeZone) => {
      const utcOffset = timeZone ? timeZone : "GMT-04:00";
      return moment().utcOffset(utcOffset);
    }

    static lastThreeMonthsUTCDate = (timeZone) => {
      const utcOffset = timeZone ? timeZone : "GMT-04:00";
      return moment().utcOffset(utcOffset).subtract(2, 'months').startOf('month').format('YYYY-MM-DD');
    };


    static getStartOfUTCDate = (date, timeZone) => {
      const utcOffset = timeZone ? timeZone : "GMT-04:00";
      return moment(date).startOf('day').utcOffset(utcOffset);
    }

    static getEndOfUTCDate = (date, timeZone) => {
      const utcOffset = timeZone ? timeZone : "GMT-04:00";
      return moment(date).endOf('day').utcOffset(utcOffset);
    }

    static moveElementInArray(arr, old_index, new_index) {
      if (new_index >= arr.length) {
          let k = new_index - arr.length + 1;
          while (k--) {
              arr.push(undefined);
          }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    };

    static buildInnerHtml(htmlText) {
        return <div dangerouslySetInnerHTML={{ __html: htmlText }} />
    }

    static isProductMaintenance(udata, productCode) {
      return udata.status[productCode] === Product.MAINTENANCE;

    }

    static isInvalidProductStatus(udata, productCode) {
      return udata && (udata.productStatus[productCode] === Product.INACTIVE || udata.productStatus[productCode] === Product.CLOSED);
    }

    static isProductActive(user, productCode) {
        return user && user.productStatus && user.productStatus[productCode] == 'ACTIVE';
    }

    static isProductSuspended(udata, productCode) {
        return  udata && udata.productStatus[productCode] === Product.WAGERING_SUSPENDED;
    }

    static isInvalidUserStatus(udata, productCode) {
        return  udata &&( udata.status[productCode] === UserStatus.INACTIVE || udata.status[productCode] === UserStatus.CLOSED);
    }
    
    static isUserSuspended(udata, productCode) {
        return  udata && (udata.status[productCode] === UserStatus.SUSPENDED || udata.status[productCode] === UserStatus.SUSPENDED_BY_COMPANY);
    }
    
    static validateUserAndProduct(productCode, translate) {
      let isValid = true
      const __udata = JSON.parse(window.atob(localStorage.getItem('__udata'))) || null
      if (__udata.auth) {
        const isValidUser = !this.isUserSuspended(__udata, productCode) && !this.isInvalidUserStatus(__udata, productCode);
        const isValidProduct = !this.isProductSuspended(__udata, productCode) && !this.isInvalidProductStatus(__udata, productCode);
        if (!isValidUser || !isValidProduct) {
          const isCredit = __udata.mode === 'credit';
          let message = '';
          if (this.isUserSuspended(__udata, productCode)) {
              message = isCredit ? translate('Your account has been Suspended, please contact your Upline for help.') : translate('Your account has been Suspended, please contact Customer Service for help.');
          } else {
              message = translate('This product is currently unavailable, please contact Customer Service for help.');
          }
          AlertComponentAction.openAlert(message)
          isValid = false
        }
      }
      return isValid
    }

    static getPeriodsMainOdds(sportId) {
        return Constants.HOCKEY_ID !== sportId ? JSON.parse(JSON.stringify(window.getDisplayPeriod(sportId, null, BetTypeGroup.HDP_OU))) || []
          : []
          ;
    }

    /**
     * Check invalid status
     */
    static isInvalidStatus(status) {
      return _.isEqual(status, UserStatus.INACTIVE) || _.isEqual(status, UserStatus.CLOSED);
    }

    /**
     * Check suspended
     */
    static isSuspended(status) {
      return _.isEqual(status, 'SUSPENDED');
    }


    static parseUDATA() {
      const rawUDATA = localStorage.getItem('__udata') || null
      if (_.isEmpty(rawUDATA)) {
        return null
      }
      try {
        return JSON.parse(window.atob(rawUDATA))
      } catch (e) {
        return null
      }
    }

    static getMapBlockedProducts() {
      const mapBlockedProducts = {};
      const __udata = this.parseUDATA();
      if(__udata) {
        const blockedProducts =  __udata.blockedProducts || [];
        const currentCountry = __udata.country || "Others";
        const currentCurrency = __udata.currency;

        _.forEach(blockedProducts, (blockProduct, productCode) => {
          const blockCountries = blockProduct.blockCountry;
          const blockCurrencies = blockProduct.blockCurrency;
          const isBlockedCountry = blockCountries && !_.isEmpty(blockCountries) && blockCountries.search(currentCountry) > 0;
          const isBlockedCurrency = currentCurrency != null && blockCurrencies !== '' && blockCurrencies.search(currentCurrency) > 0;
          
          if(isBlockedCountry || isBlockedCurrency){
            mapBlockedProducts[productCode] = blockProduct;
          }   
        })
      }
      return mapBlockedProducts
    }  

    static capitalizeFirstLetter(string) {
      if (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
      return '';
    }

    static collectTodayAndEarlyOutrightMarkets(selectedMenuItem) {
      const result = [];
      const fullMarketItems = _.get(selectedMenuItem, `['betTypeGroups'][${Market.Today}]`, [])
        .concat(_.get(selectedMenuItem, `['betTypeGroups'][${Market.Early}]`, []));
      const marketItemsFilteredOutright = _.filter(fullMarketItems, betType => _.includes(_.values(OUTRIGHT_TYPE), betType.type));
      const groupedMarketItemsByOutrightType = _.groupBy(marketItemsFilteredOutright, 'type');
  
      _.forEach(groupedMarketItemsByOutrightType, e => {
        const marketItem = {};
        Object.assign(marketItem, e[0])
        marketItem.numberEvents = _.sumBy(e, 'numberEvents');
        result.push(marketItem);
      })
      return result;
    }

    static getButtonPosition(position) {
        return !_.isEmpty(position) ? position.replaceAll("_", "-").toLowerCase() : "";
    }

    static goToButtonLink(url) {
        if (!_.isEmpty(url)) {
            window.location.href = url;
        }
    }

    static getClaimCodeByValidationCode(validationCode) {
        switch (validationCode) {
            case Constants.PROMOTION_VALIDATION.VALIDATE_WELCOME_BONUS:
                return Constants.PROMOTION_CLAIM.CLAIM_WELCOME_BONUS;
            case Constants.PROMOTION_VALIDATION.VALIDATE_REACTIVATION_BONUS:
                return Constants.PROMOTION_CLAIM.CLAIM_REACTIVATION_BONUS;
            case Constants.PROMOTION_VALIDATION.VALIDATE_CASHBACK_REBATE_BONUS:
                return Constants.PROMOTION_CLAIM.CLAIM_CASHBACK_REBATE;
            default:
                return '';
        }
    }

    static buildFormData(data) {
        const formBody = [];
        for (const property in data) {
            const encodedKey = encodeURIComponent(property);
            const encodedValue = encodeURIComponent(data[property]);
            formBody.push(encodedKey + '=' + encodedValue);
        }
        return formBody.join('&');
    }

    static scrollToTop = () => {
        $("html, body").animate({scrollTop: 0}, 'fast');
    }

    static scrollToTopWithNoAnimation = () => {
        $("html, body").scrollTop(0);
    }

    static doScrollInboxMessage = (isScroll) => {
        const element = $("html, body")
        if (isScroll) {
            element.css("overflow", "")
        } else {
            element.css("overflow", "hidden")
        }
    }
    static scrollToClass = (className) => {
        const selectedItem = $(`.${className}`);
        selectedItem.length && $('html, body').animate({scrollTop: selectedItem.offset().top - 100}, 'fast');
    }

    /**
     * 
     * @param {*} listLiveBlockedSports is an array
     * @param {*} sportId number
     * @param {*} market number
     */
    static isBlockedLiveSport(listLiveBlockedSports, sportId, market) {
      return market === Market.Live && _.includes(listLiveBlockedSports, sportId);
    }

    /**
     * The brand supports only Esports
     */
    static isEsportOnlyByBrand = () => {
      return window.env.isBrandOnlyEsport;
    }

    static buildEsportsHubUrl = (url) => {        
        return Utils.isEsportOnlyByLoginView() ? url.replace('asian', 'asian/esports-hub') : url;
    }

    static isEsportOnlyByLoginView = () => {
        return window.location.pathname.includes('/esports-hub');
      }

    /** The configuaration was applied for brand with full sports. 
     *  But some brand want it only supports esport. Bellow is the combine condition of this setting:
      1. The configuration 'isBrandOnlyEsport' in BO site is true
      2. Param sport in b2b login request is 'e-sports'      
    **/
    static isSpecifyEsportsOnlyByBrand = () => {
      return window.env.isBrandSpecifyOnlyEsport && StorageHelper.getBrowsersStorage(BROWSER_KEY.SPECIFY_SPORT) === 'e-sports';
    }
    static isArcadia() {
        return StorageHelper.getBrowsersStorage(`${BROWSER_KEY.IS_ARCADIA}_${window.env.arcadiaCookieSuffix}`) === 'true'
    }




    static themeDefaultB2BArcadia() {
        const themeDefault = _.get(window.env, 'themeDefaultB2BArcadia')
        return themeDefault && this.isArcadia() ? themeDefault : '';
    }
    
    static isEnableAnnouncement() {
        return _.get(window.env, 'enableAnnouncement');
    }

    static checkProductStatusWhenAccess() {
        return _.get(window.env, 'checkProductStatusWhenAccess');
    }

    static getLocaleByPathName(pathName) {
      if (pathName.includes("/m/")) {
        pathName = pathName.replace("/m/","/");
      }
      const parts = pathName.split('/');
      if (parts.length > 0) {
        return parts[1];
      }
      return LocalePath.en_US;
    }

    static getEuroViewUrl() {
      return window.env.fvURL;
    }
  
    static getAvailableViews = () => {
      const supportedViews = {};
      supportedViews[ViewKeys.asia] = window.env.isEnableOldAsianView || window.env.isEnableNewAsianView;
      supportedViews[ViewKeys.europe] = window.env.isEnableOldEuroMobileView;
      supportedViews[ViewKeys.standard] = window.env.isEnableFutureView;
      supportedViews[ViewKeys.newStandardView] = window.env.enableNewStandardView;
      return supportedViews;
    }

    
    static isScriptLoaded = (src) => {
      const tags = document.getElementsByTagName("script");
      const scripts = Array.prototype.slice.call(tags, 0);
      const currentScript = scripts.find((s) => s.src === src);
      return Boolean(currentScript);
    }

    static injectScript = (src)=> {
      return Utils.isScriptLoaded(src)
      ? Promise.resolve(true)
      : new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.type = "text/javascript";
          script.async = true;
          script.src = src;
          script.addEventListener('load', resolve);
          script.addEventListener('error', () => reject('Error loading script.'));
          script.addEventListener('abort', () => reject('Script loading aborted.'));
          document.head.appendChild(script);
        });
    }


  static isFullSkin() {
      return [
          "pa",
          "ps3838",
          "skin7",
          "mmx",
          "p88",
          "psp",
          "green1",
          "darkblue3",
          "skin8",
          "bookielink",
          "vipinnacle"
      ].includes(window.env.skinName);
  }

  static useOnlySBAndVSProductsForMyBets() {
    return ["mmx", "psp", "p88", "green1", "darkblue3", "skin8", "bookielink"].includes(window.env.skinName);
  }

  static getPeriodForSport(displayPeriod, spId, leagueId, betTypeGroup) {
      const periodForSport = displayPeriod[spId];
      if (periodForSport && periodForSport.excludedLeagueIDs) {
        return periodForSport.excludedLeagueIDs.includes(leagueId) 
        ? periodForSport.excludedPeriod
        : periodForSport.defaultPeriod[betTypeGroup];
      }
    return [];
  }

    static getActualGradingUnit(gradingUnit, betType, isGameInTeamName = false) {
        if (gradingUnit === GRADING_UNIT.REGULAR) {
            if (betType === BetType.THE_1X2 && !isGameInTeamName)
                return GRADING_UNIT.SETS
            else if (betType === BetType.HANDICAP || betType === BetType.HOME_TOTALS || betType === BetType.AWAY_TOTALS || betType === BetType.OU || isGameInTeamName)
                return GRADING_UNIT.GAMES
        }
        return gradingUnit
    }

    static getInfoExtraTime(dataMoreBet, periodsMoreBet, redCards = [0, 0]) {
        const isSoccer = dataMoreBet[FullEvent.sportId] === Constants.SOCCER_ID;
        if(!isSoccer) return '';

        const event = dataMoreBet[FullEvent.event];
        const extraTime = event[EventDetail.periods][3];
        let templateInfo = '';
        if (extraTime && parseInt(periodsMoreBet) === 3) {
            const scoreExtraTime = extraTime[9] || [];
            const score = RUNNING_STATE_EXTRA_TIME.includes(dataMoreBet[EventDetail.runningPeriod]) && scoreExtraTime[0] >= 0 && scoreExtraTime[1] >= 0
                            ?  `${scoreExtraTime[0]}-${scoreExtraTime[1]}` 
                            : '';
            const [homeRedCard, awayRedCard] = extraTime[12] || redCards;
            templateInfo = `
                <span class="extra-time-info"> 
                    (${event[EventDetail.homeName]} 
                    ${homeRedCard > 0 ? `<i class="home-red-card">${homeRedCard}</i>`: ''}
                    <span class="extra-score">${score || ' - '}</span>
                    ${awayRedCard > 0 ? `<i class="away-red-card">${awayRedCard}</i>`: ''}
                    ${event[EventDetail.awayName]})
                </span>
            `;
        }
        return templateInfo;
    }

    static getTypeEventTennis(event, parentEvent) {
        let result = {
          isRegularEvent: event[EventDetail.unitResults] === GRADING_UNIT_TYPE.REGULAR,
          isSetEvent: event[EventDetail.unitResults] === GRADING_UNIT_TYPE.SETS,
          isGameEvent: event[EventDetail.unitResults] === GRADING_UNIT_TYPE.GAMES,
          isRegularEventParent: parentEvent && parentEvent[EventDetail.unitResults] === GRADING_UNIT_TYPE.REGULAR,
          isSetEventParent: parentEvent && parentEvent[EventDetail.unitResults] === GRADING_UNIT_TYPE.SETS,
          isGameEventParent: parentEvent && parentEvent[EventDetail.unitResults] === GRADING_UNIT_TYPE.GAMES
        };
        if(event[EventDetail.isGameInTeamName]) {
          result.isRegularEvent = false;
          result.isGameEvent = true;
        }
        return result;
    }

    static getMoreBetTeamTotal(event) {
        let periodsMoreBet = [];
        let firstCountMoreBet = 0;
        const countMoreBet = event[EventDetail.moreBets] + event[EventDetail.totalOutrightOdds];
        const evPeriod = event[EventDetail.periods];
        const periodsEvent = Object.keys(evPeriod);
        periodsEvent.forEach((period, index) => {
          if(evPeriod && evPeriod[period] && index > 0) {
            firstCountMoreBet += evPeriod[period][6];
            periodsMoreBet.push(evPeriod[period][6] - 1);
          }
        });
        periodsMoreBet.unshift(countMoreBet - firstCountMoreBet);
        return periodsMoreBet;
    }

      static fetchParentId(leagueEvent) {
        let tempEvId = 0;
        const leagueParentId = leagueEvent.reduce((eventsId, event) => {
          if (event[EventDetail.parentEventId] === 0 && !eventsId.includes(event[EventDetail.id])) {
            eventsId.push(event[EventDetail.id]);
            tempEvId = event[EventDetail.id];
          } else if (event[EventDetail.parentEventId] !== 0 && tempEvId !== event[EventDetail.parentEventId] && !eventsId.includes(event[EventDetail.parentId])) {
            eventsId.push(event[EventDetail.parentEventId]);
            tempEvId = event[EventDetail.parentEventId];
          }
          return eventsId;
        }, []);
        return leagueParentId;
      }
    
      static getPeriodMoreBet(periods, filterPeriods) {
        const result = periods.reduce((listPeriods, item) => {
          if(item === periods[0] || !filterPeriods.includes(item)) {
            listPeriods.push(item);
          }
          return listPeriods;
        }, []);
        return result;
      }

    static convertPageDefault(pageType) {
        let type;
        switch (pageType.toLowerCase()) {
            case 'ml_1x2':
                type = PAGETYPE.ML_1X2
                break
            case 'team_total':
                type = PAGETYPE.TEAM_TOTAL
                break
            default:
                type = PAGETYPE.TODAY
        }
        return type;
    }

    static isNotSupportPublicClassFields() {
        const agent = window.navigator.userAgent;
        const browsers = agent.match(/(Chrome|CriOS|Version(?=\/))\/?\s*(\d+)/i);
        const isChrome = browsers && browsers[1] === 'Chrome';
        const isSafari = !isChrome && browsers && browsers[1] === 'Version';
        if (isChrome) {
          return browsers[2] < Constants.VERSION_NOT_SUPPORTED.CHROME;
        } else if (isSafari){
          return browsers[2] < Constants.VERSION_NOT_SUPPORTED.SAFARI;
        }
        return false;
      } 
      
    static isEnableFeatureVIP() {
        return _.get(window.env, 'enableFeatureVIP');
    }

    static isVIPAccount() {
        const { auth, currentTierId } = { ...this.getUdata() }
        const VIP_ID = _.invert(VIP_TIER);

        return Utils.isEnableFeatureVIP() && auth && ![VIP_ID.Regular, VIP_ID.Bronze].includes(currentTierId.toString());
    }

    static getPreferenceViews() {
      const availableViews = Utils.getAvailableViews();
      const __udata = Utils.getUdata();
      return  [
        { 
          label: 'Asian View', 
          value: VIEW.ASIAN,
          visible: __udata.type === USER_TYPE.CASH_PLAYER 
            ? availableViews[ViewKeys.asia] && (
              (__udata.supportedViews || '').includes(VIEW.ASIAN) ||
              (__udata.supportedViews || '').includes(VIEW.COMPACT)
            )
            : availableViews[ViewKeys.asia]
        },
        { 
          label: "Europe View",
          value: VIEW.STANDARD,
          visible: !availableViews[ViewKeys.newStandardView] 
            ? __udata.type === USER_TYPE.CASH_PLAYER 
                ? availableViews[ViewKeys.standard] && (__udata.supportedViews || '').includes(VIEW.STANDARD)
                : availableViews[ViewKeys.standard]
            : false
        },
      ].filter(view => view.visible);
    }

    static getWhiteLabelPreferenceViews() {
      const availableViews = Utils.getAvailableViews();
      return  [
        { 
          label: 'Asian',
          value: VIEW.ASIAN,
          visible: availableViews[ViewKeys.asia]
        },
        { 
          label: 'Europe', 
          value: VIEW.EUROPE ,
          visible:  availableViews[ViewKeys.europe] 
        }
      ].filter(view => view.visible);
    }
    
    static isIniFrame() {
      return window.self !== window.top;
    }

    static getLangByLocale(locale){
      if (!locale) {
        // default by setting in preference
        locale = Utils.getUdata().locale
      }
      for (const key in ArcadiaLocaleMap) {
        if (ArcadiaLocaleMap.hasOwnProperty(key) && ArcadiaLocaleMap[key] === locale) {
          return key;
        }
      }
      return this.getCurrentLang();
    }

    static isDSTApiEnableOrTestAccount() {
        return _.get(this.getUdata(), 'dstApiEnabledOrTestAccount', false);
    }
    //return true if product status = Active
    static validateProduct = (user, productName) => {
        const udata = JSON.parse(window.atob(localStorage.getItem('__udata')));
        const mapBlockedProducts = Utils.getMapBlockedProducts(udata);
        const productStatus = _.get(user, 'productStatus.' + productName);
        const isInvalidProductStatus = Utils.isInvalidStatus(productStatus);
        if (isInvalidProductStatus || mapBlockedProducts[productName]) {
            return false;
        }
        return true;
    }
    static isMobileAsianView = () => {
      return MOBILE_VIEWS.ASIA === Utils.getViewByURLPath();
    }

    static getObjectKeyByValue = (obj, value) => {
        for (let key of Object.keys(obj)) {
          if (obj[key] === value) {
            return key
          }
        }
      }
    static getGradingUnit = (sportId, gradingUnit, translate) => {
        if (window.env.isShowGradingUnit && sportId === Constants.TENNIS_ID && gradingUnit)
            return `(${translate(gradingUnit)})`;
        return '';
    }

    static calculatorStakeRoundRobin(maxRiskStake, roundRobinOptions, maxRoundRobinTotalRisk, maxRoundRobinTotalWin, selectedRoundRobins) {
        const stakeRoundRobin = (roundRobinOptions || []).reduce((roundRobin, option) => {
            if (selectedRoundRobins.indexOf(option.roundRobinOption) > -1) {
                roundRobin.numberOfBets += option.possibleWagers;
                roundRobin.unroundedDecimalOdds += option.unroundedDecimalOdds - 1;
            }
            return roundRobin;
        }, { numberOfBets: 0, unroundedDecimalOdds: 0 });

        if ((selectedRoundRobins.length === 1 && selectedRoundRobins[0] !== RoundRobinOption.PARLAY) || selectedRoundRobins.length > 1) {
            const maxRiskStakeBasedOnMaxTotalRisk = maxRoundRobinTotalRisk / stakeRoundRobin.numberOfBets;
            const maxRiskStakeBasedOnMaxTotalWin = maxRoundRobinTotalWin / stakeRoundRobin.unroundedDecimalOdds;
            return Math.min(maxRiskStakeBasedOnMaxTotalRisk, maxRiskStakeBasedOnMaxTotalWin);
        }
        return maxRiskStake;
    }

    static findTeaserRemoveLeg = (asiaTeaserTicket, asiaTeaserSelections) => {
        if(!asiaTeaserTicket.legs) return
        const removedLeg = asiaTeaserTicket.legs.find(ticket => asiaTeaserSelections.every(sel => ticket.selectionId !== sel.selection));
        return removedLeg ? removedLeg.legId : '';
    }
    static getBettingRulesUrl = (urlTemplate, language) => {
        let langBettingRule = (window.env.langBettingRuleSupport || Constants.LANG_BETTING_RULE_SUPPORT).includes(language) ? language : 'en_US';

        let prefixLanguage = '';
        const langSupportPrefix = ['en_US', 'ru_RU', 'zh_CN', 'ko_KR'];
        if (langSupportPrefix.includes(langBettingRule)) {
            var arrLangSplit = langBettingRule.split('_')
            prefixLanguage = arrLangSplit ? arrLangSplit[0] : 'en';
        } else {
            prefixLanguage = langBettingRule.replace('_', '-').toLowerCase();
        }
        let lang = langBettingRule.replace('_', '-').toLowerCase();
        let suffixLanguage = Utils.getCurrentLangForBettingRule(langBettingRule);
        let bettingRuleUrl = urlTemplate
            .replace(/{lang}/g, lang)
            .replace(/{prefix-language}/g, prefixLanguage)
            .replace(/{language}/g, langBettingRule === 'en_US' ? prefixLanguage : lang);
        if (langBettingRule !== 'en_US') {
            bettingRuleUrl = bettingRuleUrl.replace(/{suffix-language}/g, suffixLanguage);
        } else {
            bettingRuleUrl = bettingRuleUrl.replace(/-{suffix-language}/g, '');
        }
        return bettingRuleUrl;

    }

    static getCurrentLangForBettingRule = (lang) => {
        let currentLanguage = lang.toLocaleLowerCase();
        let currentLang = 'en';
        const list = { 'zh_tw': 'ch', 'zh_cn': 'cn', 'pt_br': 'pt-br' };
        const supportedLanguage = ['af', 'ar', 'bg', 'ch', 'zh-cn', 'cs', 'da', 'nl', 'en', 'et', 'fi', 'fr', 'de', 'el', 'hu', 'it', 'ja', 'ko', 'no', 'pl', 'pt-br', 'ro', 'ru', 'sr', 'sk', 'es', 'sv', 'th', 'tr'];
        if (currentLanguage !== undefined) {
            if (list[currentLanguage]) {
                currentLang = list[currentLanguage];
            } else {
                currentLanguage = currentLanguage.substr(0, 2);
                currentLang = supportedLanguage.includes(currentLanguage) ? currentLanguage : "en";
            }
        }
        return currentLang;
    };

    static getSportTeasers = (sportsMenuStore) => {
        return _.filter(sportsMenuStore.getAsiaLeftMenuItem, item => item.sportId === Constants.BASKETBALL_ID || item.sportId === Constants.FOOTBALL_ID)
    }

    static isTeaserSportEnabled = (sportTeaserHasEvent, sportId) => {
        return !!sportTeaserHasEvent.find(sportTeaser => sportTeaser.sportId === sportId)
    }

    static isLogo25YearEnabled = (logoTimes) => {
        if (!logoTimes) return false;
        const currentDate = new Date().getTime();
        const startDate = new Date(logoTimes.startDate).getTime();
        const endDate = new Date(logoTimes.endDate).getTime();
        return startDate <= currentDate && currentDate <= endDate;
    }

    static getDatesRangeSpecialDate = (key, defaultDatesRange = Constants.DEFAULT_LOGO_DATES) => {
        const localStorageTimes = Utils.convertStringToJSON((localStorage.getItem(key)));
        if (!_.isEmpty(localStorageTimes)) {
            return localStorageTimes;
        }
        return window.env && window.env[key] && !_.isEmpty(Utils.convertStringToJSON(window.env[key]))
            ? Utils.convertStringToJSON(window.env[key])
            :  defaultDatesRange;
    }
    
    static openImageNewTab(imgSrc) {
        //imgSrc with format data:image/.extension;base64
        const image = new Image();
        image.src = imgSrc;
        window.open("about:blank").document.write(image.outerHTML);
    }

    static getDefaultLanguageByBrand = (lang) => {
        const defaultLanguage = window.env.defaultLanguageByBrand === 'en-GB'
            ? 'en_US'
            : window.env.defaultLanguageByBrand;
        return Utils.mapLangCountryCode()[lang]
            ? lang
            : _.invert(Utils.mapLangCountryCode())[defaultLanguage.replace('-', '_')];
    }
    // check if propslabel is Yes/No
    static isHiddenHandicap = (propsLabel) => {
        return ['Yes', 'No'].includes(propsLabel);
    }

    static standardizeEventsParams(options) {
        return Object.keys(standardizeEventParamsMap).reduce((rs, key) => {
            rs[key] = !_.isNil(options[key]) ? options[key] : (standardizeEventParamsMap[key]);
            return rs;
        }, {});
    }

    static getOrderedPeriodDisplay = (avaliablePeriods, ocg, sportId) => {
        const teamPropsPriorityPeriods = Constants.TEAM_PROPS_PRIORITY_PERIODS[sportId];
        if (["Player Props", "Goalscorer"].includes(ocg) || _.isEmpty(teamPropsPriorityPeriods)) return avaliablePeriods;
        const priorityPeriods = avaliablePeriods
            .filter(period => teamPropsPriorityPeriods.includes(parseInt(period)));
        const uniquePeriods = new Set([...priorityPeriods.concat(avaliablePeriods)]);
        return [...uniquePeriods];
    }
    
    static getGameByPath(position, url) {
        const arrPath = url ? url.split('/') : window.location.href.split('/');
        return arrPath[position] ? arrPath[position] : '';
    }
  /**
   * to format Time zone Code
   * input ex:UTC +12:45
   * output ex :+12:45
   */
  static formatTimeZoneCode(timeZoneCode) {
    if (!timeZoneCode) return "";
    const splitValue = timeZoneCode.split(" ");
    if (splitValue.length === 1) return "";
    let text = timeZoneCode.split(" ")[1];
    const sufix = ":00";
    switch (text.length) {
      case 2:
        // for timeZone with 2 character like +9
        return text.replace(text.substring(0, 1), text.substring(0, 1).concat('0')).concat(sufix);
      case 3:
        // for timeZone with 3 character +10
        return text.concat(sufix);
      case 5:
        // for timeZone like +9:30
        return text.replace(text.substring(0, 1), text.substring(0, 1).concat('0')).concat(text.substring(1, text.length));
      default:
        //ignore if timeZone length is higher than 3 character for Example:GMT +12:45
        return text;
    }
  }

    static translateMaketName(name, localTranslate, periodsDescription, specificLanguage) {
        if (localTranslate === 'periods') {
            const infoMarket = name.split('_') || [];
            return Utils.getPeriodName(periodsDescription, infoMarket[0], infoMarket[1], false);
        }

        // Combine the translation key based on localTranslate
        const translationKey = localTranslate ? `${localTranslate}:${name}` : name;
        return i18next.t(translationKey, specificLanguage);
    }

    static convertPeriodDescriptionData(data) {
        return data.map((periods) => ({
            sportId: periods[GROUP_SPORT_PERIODS.sportId],
            periodsDescription: periods[GROUP_SPORT_PERIODS.groupPeriod]
        }));
    }

    static isShowLiveScoreOldStyle(sportId) {
        return Constants.INNING_LIVE_POSITION_CENTER.includes(sportId);
    }
  
  static getOddsFormatLabel = (betType, oddsFormat) => {
    if (BetType.THE_1X2 === betType && oddsFormat !== OddsFormat.EU && oddsFormat !== OddsFormat.AM) {
      oddsFormat = OddsFormat.EU; 
    }
    
    return `(${OddsFormatShortLabel[oddsFormat]})`;
  }

    static filterOutDuplicateData = (data) => {
        return data.reduce((acc, item) => {
            if (!_.isEqual(acc.find(el => _.isEqual(el, item)), item)) {
                acc.push(item);
            }
            return acc;
        }, []);
    }

  static getB2BParentDomain = () => {
    if (window.env.isB2B) {
      try {
        return _.get(window, "location.ancestorOrigins[0]", document.referrer || "");
      } catch (err) {
        return document.referrer || '';
      }
    }
    return '';
  }

  static scrollTo(element, target, duration) {
    if (duration <= 0 || element.scrollTop === target) return
    setTimeout(() => {
      const perTick = (target / duration) * 10
      element.scrollTop = element.scrollTop + perTick
      this.scrollTo(element, target, duration - 10)
    }, 10)
  }

  static scrollWindowTo(target, duration) {
    // we need to try both elements for a browser hack;
    // chrome uses html, safari uses body. go figure!
    const html = document.getElementsByTagName('html')[0]
    const body = document.body
    const element = html.scrollTop !== 0 ? html : body
    const distanceToTop = target - element.scrollTop
    this.scrollTo(element, distanceToTop, duration)
  }
  
  static getMomentTZ(date, timeZone) {
    return date ? moment.tz(date, timeZone).locale(Constants.DEFAULT_LOCALE) : moment().locale(Constants.DEFAULT_LOCALE).tz(timeZone);
    }

    static formatLocaleCode(productCode) {
        const lang = Utils.getCurrentLang()
        if (![LocalePath.zh_CN, LocalePath.zh_TW].includes(lang)) {
            return lang;
        }
        switch (productCode) {
            case PRODUCT_CODE.ZNTH:
                return lang === LocalePath.zh_CN ? ZENYTH_LOCALE_MAP.ZH_CN : ZENYTH_LOCALE_MAP.ZH_TW
            case PRODUCT_CODE.PP:
                return ZENYTH_LOCALE_MAP.ZH_CN;
            default:
                return lang
        }
    }

    static goToApGaming(url) {
        try {
            const languages = JSON.parse(window.env.languagesSupportedApGaming)
            window.open(url.replace("{lang}", languages[Utils.getCurrentLang()]))
        } catch (e) {
            window.open(url.replace("{lang}", 'en'))
        }
    }
  
  static getPathObj(pathname, route) {
    return matchPath(pathname, {
      path: route,
      exact: true,
    });
  }
  static getParamsFromAvailablePathname(pathname, routes) {
    const matchRoute = routes
      .map((route) => Utils.getPathObj(pathname, route))
      .filter((match) => match)[0]
    return _.get(matchRoute, 'params', null);
  }

  static getHelpPageLocaleURL = (localeCode) => {
    const helpPageLanguages = Utils.convertStringToJSON(window.env.helpPageSupportingLanguages) || "";
    const langCode = Utils.toLocaleCode(localeCode)
    return helpPageLanguages.hasOwnProperty(langCode) ? helpPageLanguages[langCode] : helpPageLanguages['en_US'];
  }

  static postMessageToParent = (msgCode, msgData) => {
    window.parent.postMessage({
        msgCode,
        msgData
    }, "*");
  }

  static passHeightToParent = (height) => {
    Utils.postMessageToParent("setIFrameHeight", {
        height: `${height}px`
    })
    }

    static isValidProductUserType = (productName) => {
        const udata = Utils.getUdata()
        switch (udata.productUserType[productName === 'casino' ? PRODUCT_CODE.CR855 : productName]) {
            case 'BOTH':
                return true
            case 'CASH':
                return udata.type === 'CASH_PLAYER'
            case 'CREDIT':
                return udata.type === 'PLAYER'
            default:
                return false
        }
    };

    static canShowThePopup() {
      const needToChangePW = localStorage.getItem('_needToChangePW')
      const isShowAcceptTC = JSON.parse(StorageHelper.getBrowsersStorage(BROWSER_KEY.IS_SHOW_ACCEPT_TC) || 'false')
      return !needToChangePW && !isShowAcceptTC
    }
    static isSessionExpired = () => {
        return Boolean(localStorage.getItem(LOCAL_STORAGE_KEY.SESSION_EXPIRED));
    }

    static isOpenNewBetslipPopup() {
        const __udata = Utils.getUdata()
        return Utils.canShowThePopup() && window.env.enableNewBetslip && __udata.newBetslipPopupEnabled && !Utils.isArcadia()
    }

    static isOpenLiveParlaysNotify() {
        const __udata = Utils.getUdata()
        return window.env.announcementLiveParlaysPopupEnabled &&
            __udata.liveParlaysPopupEnabled &&
            !window.env.isWhiteLabel &&
            Utils.canShowThePopup() &&
            !Utils.isArcadia()
        ;
    }

    static isOpensAnnouncementLoginWith2FA() {
      return window.env.enable2FALogin 
        && Utils.canShowThePopup() 
        && !_.get(Utils.getUdata(), 'showedAnnouncementLoginWith2FA', false)
    }

    static getPopupList() {
        const popupList = []
        if(Utils.isSessionExpired()) {
            return [Constants.POPUP_LIST.SESSION_EXPIRED]
        }
        if(Utils.isOpenNewBetslipPopup()) {
            popupList.push(Constants.POPUP_LIST.NEW_BETSLIP_MOBILE)
        }
        if(Utils.isOpenLiveParlaysNotify()) {
            popupList.push(Constants.POPUP_LIST.LIVE_PARLAYS)
        }
        if(Utils.isOpensAnnouncementLoginWith2FA()) {
            popupList.push(Constants.POPUP_LIST.LOGIN_2FA_ENABLE)
        }
        return popupList;
    }
    static getResettleInfoArr(resettleInfo) {
        return resettleInfo ? resettleInfo.split("-") : ["", ""]
    }

    static openCMSWindow(url) {
        const lang = Utils.getCurrentLang()
        const langForStaticUrl = Utils.getLangForStaticUrl()
        if(window.env.isNewCMSEnabled) {
            DirectusUtil.getBrandInfoFromDirectus(window.env.skinName).then(brandInfo => {
                if (brandInfo.length > 0) {
                    window.open(url.replace("{lang}", lang).replace("{skin}", brandInfo[0].brand_alias));
                }
            })
            return;
        }
        window.open(url.replace("{lang}",  langForStaticUrl));
    }

    static formatGuestSetting(data, dataBlockedAll, isLive) {
        if (!data) return []
        let result = data.split(";").map(item => {
            const parts = item.split('-')
            if (parts.length !== 2) {
                return null
            }
            const key = parts[0]
            const values = parts[1].split(',').map(Number).filter(Number.isFinite) // filter out NaN
            return {
                [key]: values
            }
        }).filter(item => item !== null)
        if (!this.isEmpty(dataBlockedAll) && isLive) {
            const dataBlockAllSport = dataBlockedAll.filter(item => Object.values(item).some(block => block.includes(BLOCKED_LEAGUE_NON_LOGIN.BLOCKED_ALL)))
            // for live event we will depend on all first if this sports has blocked all so live will block all
            result = [
                ...result.map(item => {
                    const sportId = parseInt(Object.keys(item)[0], 10)
                    const arrBlockId = this.getArrBlockSetting(dataBlockedAll, sportId)
                    if (!this.isEmpty(arrBlockId) && arrBlockId.includes(BLOCKED_LEAGUE_NON_LOGIN.BLOCKED_ALL)) {
                        item[sportId] = [BLOCKED_LEAGUE_NON_LOGIN.BLOCKED_ALL]
                    }
                    return item
                }), ...dataBlockAllSport
            ]
        }
        return result
    }

    static filterLeagueByGuestSetting(event, guestSettingAll, guestSettingLive) {
        return event.map(item => {
            const arrBlockId = [
                ...this.getArrBlockSetting(guestSettingAll, item[BLOCKED_LEAGUE_NON_LOGIN.SPORT_ID]),
                !this.isEmpty(guestSettingLive)
                    ? this.getArrBlockSetting(guestSettingLive, item[BLOCKED_LEAGUE_NON_LOGIN.SPORT_ID])
                    : []
            ]
            if (!this.isEmpty(arrBlockId)) {
                // in case guest setting had 0 value for leagueId it's mean we will block this sport
                item[BLOCKED_LEAGUE_NON_LOGIN.LEAGUE_LIST] = arrBlockId.includes(BLOCKED_LEAGUE_NON_LOGIN.BLOCKED_ALL)
                    ? []
                    : item[BLOCKED_LEAGUE_NON_LOGIN.LEAGUE_LIST].filter(league => !arrBlockId.includes(league[BLOCKED_LEAGUE_NON_LOGIN.SPORT_ID]))
            }
            return item
        })
    }

    static getArrBlockSetting(guestSetting, sportId) {
        const sportsHasBlock = !this.isEmpty(guestSetting) ? guestSetting.find(item => item[sportId]) : {}
        return !this.isEmpty(sportsHasBlock) && sportId !== 0 ? sportsHasBlock[sportId] : []
    }

    static getPathSegments() {
        return window.location.pathname.split('/')
    }

    static getSportIdOnUrl() {
        const sportName = this.getPathSegments()[5] || ''
        return SPORT(sportName, true) || 0
    }

    static getLeagueIdOnUrl() {
        const leagueId = Number(this.getPathSegments()[7])
        if (isNaN(leagueId)) {
            return 0
        }
        return leagueId
    }

    static getGameIdOnUrl() {
        return this.getPathSegments()[5] || ''
    }

    static getLeagueIdsFromSportMarketResponse({data = {}, isEsport}) {
        if (_.isEmpty(data)) {
            return {
                live: [],
                today: [],
                early: []
            }
        }
        return {
            live: (_.get(data, `[${SportMarketMap.live}][${isEsport ? ESportItemMap.allLeagues : SportItemMap.todayLeagues}]`) || '').split(',').filter(Boolean),
            today: (_.get(data, `[${SportMarketMap.today_soon}][${isEsport ? ESportItemMap.allLeagues : SportItemMap.todayLeagues}]`) || '').split(',').filter(Boolean),
            early: (_.get(data, `[${SportMarketMap.early_pregame}][${isEsport ? ESportItemMap.allLeagues : SportItemMap.earlyLeagues}]`) || '').split(',').filter(Boolean),
        }
    }

    static isNewLogoPinnacle888Enabled() {
        return window.env && window.env.newLogoPinnacle888Enabled && this.isPA()
    }
    
    static betslipWagerRefreshTime() {
        return window.env.betslipWagersRefreshTime * 1000
    }

    static getUnit = (unit, originalUnit) => {
      return window.env.enableRemoveRegularTextMobileEuro &&
        originalUnit === GRADING_UNIT.REGULAR
        ? ""
        : unit;
    }

    static hasMultiLineTeamTotal(periodsData, periods) {
        return periods.some(period => {
            const ttData = _.get(periodsData, `[${period}][${PeriodDetail.tt}]`) || [];
            const homeOddData = ttData[TeamType.home];
            const awayOddData = ttData[TeamType.away];
            return ttData.length > 0 && (
                (homeOddData && homeOddData.some(item => Array.isArray(item)))
                || (awayOddData && awayOddData.some(item => Array.isArray(item)))
            );
        })
    }
    static getTokenFromURL(search = '') {
        const params = new URLSearchParams(search)
        const stringParams = search.split('?')[1]
        if (params.has('ito') && stringParams) {
            const params_ = stringParams.split('&').reduce((result, item) => {
                const [key, value] = item.split('=')
                result[key] = value
                return result
            }, {})
            return params_['ito']
        }

        return null
    }

    static getParamFromUrl(paramName) {
        if (!paramName) return ''
        const { search } = window.location
        const params = new URLSearchParams(search);
        return params.get(paramName)
    }

    static removeSearchParamFromUrl(urlObj) {
        if (!urlObj) return
        urlObj.search = ''
        const newUrl = urlObj.toString()
        window.history.replaceState(null, '', newUrl)
    }
    
    static applyBodyTheme(containerElement, themeOptions = {}, enableTheme = true) {
        if (!containerElement || !enableTheme) return;

        const {
            className = '',
            backgroundClassName = '',
            shouldApply = false,
            createBackground = true
        } = themeOptions;

        if (!className) return;

        if (shouldApply) {
            if (!containerElement.classList.contains(className)) {
                containerElement.classList.add(className);
            }
        } else {
            containerElement.classList.remove(className);
        }

        if (createBackground && backgroundClassName) {
            const existingBackground = containerElement.querySelector(`.${backgroundClassName}`);

            if (shouldApply) {
                if (!existingBackground) {
                    const backgroundDiv = document.createElement('div');
                    backgroundDiv.className = backgroundClassName;
                    containerElement.insertBefore(backgroundDiv, containerElement.firstChild);
                }
            } else if (existingBackground) {
                existingBackground.remove();
            }
        }
    }

    static getThemeClass(themeOptions = {}, enableTheme = true) {
        if (!enableTheme) return '';
        const { className = '', shouldApply = false, origin = '' } = themeOptions;
        return `${origin} ${shouldApply ? className : ''}`.trim();
    }

    static cleanupBodyTheme(containerElement, themeOptions = {}, enableTheme = true) {
        if (!containerElement || !enableTheme) return;

        const { className = '', backgroundClassName = '' } = themeOptions;

        if (className) {
            containerElement.classList.remove(className);
        }

        if (backgroundClassName) {
            const backgroundElement = containerElement.querySelector(`.${backgroundClassName}`);
            if (backgroundElement) {
                backgroundElement.remove();
            }
        }
    }

    static isSelectedAllCategory = (categoryName) => {
        const allCategory = [Constants.ALL_GAMES_TITLE.CASINO, Constants.ALL_GAMES_TITLE.LIVE_CASINO, Constants.ALL_GAMES_TITLE.CHESS_AND_CARDS];
        return window.env.casinoSequenceCategoryEnabled && allCategory.includes(categoryName.trim().toLocaleLowerCase());
    }

  static encodeAndReplaceSpaceCategoryName(categoryName) {
    return encodeURIComponent(categoryName.replaceAll(" ", "-").toLowerCase())
  }

  static getCategoryNameByPath(pathname) {
    const match = Object.values(CATEGORY_PATH)
      .map(categoryPath =>
        matchPath(pathname,
          { path: categoryPath, exact: true })
      )
      .find(currentPath => currentPath !== null)
    return _.get(match, 'params.categoryName')
  }
  
  static cleanUrlParams(url) {
    const [base, query] = url.split("?");
    const params = new URLSearchParams(query);

    for (const [key, value] of params.entries()) {
      const str = value !== undefined && value !== null ? String(value) : "";
      const decoded = decodeURIComponent(str);

      if (!decoded || decoded === "null" || decoded === "undefined" || decoded === "[object Object]") {
        params.delete(key);
      }
    }

    return `${base}?${params.toString()}`;
 }

  static getCharactersFirstLastNameSignUpForm(lang) {
     const charactersSignUpForm = JSON.parse(window.env.maxNameLengthSignUpForm)
     return charactersSignUpForm[lang] || charactersSignUpForm[Constants.DEFAULT_LOCALE] || Constants.MAX_LENGTH.DEFAULT_FIRST_LAST_NAME_LENGTH;
  }

  /**
  * Replace "-" to "_" for matching the translation
  * EX: live-casino -> live_casino
  * @param {*} dataToParse -> The name that need to parse 
  * @returns The parsed name
 */
  static parsePrefix(dataToParse){
    if(!dataToParse) return "";
    return dataToParse.split("-").join("_");
  }

  /**
   * Get meta data based on current view and sportsGamesMetaData. Default to 'main' if no view matched
   * @returns The title and desc
   */
  static getMetaData(){
    const parts = window.location.pathname.split("/") || [];
    const dataToUpdate = (window.env.sportsGamesMetaData || []).find((config) => {
        return parts.includes(config);
    });
    if(dataToUpdate){
        const prefix = this.parsePrefix(dataToUpdate);
        return { 
          title: i18next.t(prefix.toUpperCase() + "_PAGE_TITLE"), 
          desc: i18next.t(prefix.toUpperCase() + "_PAGE_DESC")
        };
    }
    if(parts.includes("sports")){
        return { 
          title: i18next.t("SPORTS_PAGE_TITLE"), 
          desc: i18next.t("SPORTS_PAGE_DESC")
        };
    }
    if(parts.includes("esports")){
        return { 
          title: i18next.t("E_SPORTS_PAGE_TITLE"), 
          desc: i18next.t("E_SPORTS_PAGE_DESC")
        };
    }
    return { 
      title: i18next.t("MAIN_PAGE_TITLE"), 
      desc: i18next.t("MAIN_PAGE_DESC")
    };
  }

  /**
   * Update the meta description, if it does not exist, create a new one
   */
  static updateMetaDesc(){
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
    meta = document.createElement('meta');
    meta.name = "description";
    document.head.appendChild(meta);
    }
    meta.content = this.getMetaData().desc;
  }

  /**
   * Update meta title and meta description of website
   */
  static updateMetaData(){
        document.title = this.getMetaData().title;
        this.updateMetaDesc();
  }

  static getPageTitle() {
    if (window.env.isB2B) {
      return window.env.documentTitle || window.env.metaTitle;
    }
    if(!_.isEmpty(window.env.sportsGamesMetaData) && Utils.isPA()){
        const title = this.getMetaData().title
        this.updateMetaDesc()
        return title;
    }
    
    const originalKey = `${Utils.getCurrentSkin()}${window.env.newLogoPinnacle888Enabled
      ? '.pageTitlePinnacle888'
      : '.pageTitle'}`
    const defaultPageTitle = i18next.t(`${Utils.getCurrentSkin()}.pageTitle`)
    return i18next.t(originalKey, defaultPageTitle)
  }

  static updateZendeskLocale = (currentLanguage) => {
    try {
      // for new Messaging setting
      // eslint-disable-next-line no-undef
      zE('messenger:set', 'locale', currentLanguage)
    } catch (e) {
      try {
        // for Widget Classic
        // eslint-disable-next-line no-undef
        zE('webWidget', 'setLocale', currentLanguage);
      } catch (error) {
        console.error('Error change language Zendesk Widget: ', error)
      }
    }
  }
  static getRegradeWagerInfo(wager) {
    const { resettleInfo, masterWagerId, wagerNumber } = wager || {};
    const [resettleWagerId = "", regradeStatus = ""] = _.split(
      resettleInfo,
      "-"
    );

    const regradeWagerId =
      resettleWagerId &&
        masterWagerId !== 0 &&
        masterWagerId !== _.toInteger(resettleWagerId)
        ? `${masterWagerId}-${wagerNumber}`
        : resettleWagerId;

    return { regradeWagerId, regradeStatus };
  }

  static generateAmount = (amount) => {
    return parseFloat(amount) > 0 ? `-${amount}` : amount;
  };

  static convertAffectedAmount(transaction) {
    const conditionToConvert =
      transaction.status === Constants.WAGER_STATUS.OPEN || transaction.txnType === STATEMENTS.TXN_TYPE.WITHDRAWAL;
    const result = { value: 0, status: "" };
    if (conditionToConvert) {
      result.value = Utils.generateAmount(transaction.formattedAffectedAmount);
    } else {
      result.value = transaction.formattedAffectedAmount;
    }

    result.status = result.value > 0 ? Constants.WAGER_STATUS.WIN : Constants.WAGER_STATUS.LOSS;

    return result;
  }

  static formatTransactionStatus({ rowData = {}, translate = (key) => key }) {
    const statusLabels = {
      REJECTED: "Rejected",
      CANCELLED: "Cancelled",
      PLACED: "Placed",
      WIN: "Win",
      LOSS: "Loss",
      REFUNDED: "Refunded",
    };

    const getWagerStatus = () => {
      switch (rowData.status) {
        case Constants.WAGER_STATUS.OPEN:
          return `${txnType} ${statusLabels.PLACED}`;
        case Constants.WAGER_STATUS.SETTLED: {
          const { regradeStatus } = Utils.getRegradeWagerInfo({
            resettleInfo: rowData.resettleInfo,
            masterWagerId: rowData.masterWagerId,
            wagerNumber: rowData.wagerNumber,
          });

          if (regradeStatus) {
            return `${txnType} ${statusLabels[regradeStatus]}`;
          }

          if (rowData.result === 1 || rowData.pnl > 0) {
            return `${txnType} ${statusLabels.WIN}`;
          }

          if (rowData.result === 2 || rowData.pnl < 0) {
            return `${txnType} ${statusLabels.LOSS}`;
          }

          return `${txnType} ${rowData.affectedAmount === 0
            ? statusLabels.LOSS
            : statusLabels.REFUNDED
            }`;
        }
        default:
          return `${txnType} ${translate(
            _.get(statusLabels, rowData.status, rowData.status)
          )}`;
      }
    };

    const getTransferStatus = () => {
      switch (rowData.status) {
        case Constants.WAGER_STATUS.REJECTED:
          return translate(STATEMENTS.TRANSFER.ERROR);
        case Constants.WAGER_STATUS.SUCCESS: 
          const fromTo = rowData.formattedAffectedAmount > 0 ? STATEMENTS.TRANSFER.FROM : STATEMENTS.TRANSFER.TO;
          const txnKey = `${rowData.txnType}_${fromTo}`;
          return i18next.t(txnKey, { 0: rowData.refLoginId });
        default:
          return txnType;
      }
    };

    let txnType = translate(_.startCase(_.toLower(rowData.txnType || "")));

    if (rowData.txnType === STATEMENTS.TXN_TYPE.WAGER) {
      return getWagerStatus();
    }

    if (_.includes([STATEMENTS.TXN_TYPE.TRANSFER, STATEMENTS.TXN_TYPE.ATA_TRANSFER], rowData.txnType)) {
      return getTransferStatus();
    }

    const isFeeReimbursement =
      rowData.txnType === STATEMENTS.TXN_TYPE.FEE_ADJUSTMENT && !rowData.manual;
    txnType = `${isFeeReimbursement ? STATEMENTS.TXN_TYPE.FEE_REIMBURSEMENT : rowData.txnType}_${rowData.status}`;

    return translate(txnType);
  }

  static formatDateBetDetails(date, timeZoneId) {
    try {
        return date
          ? moment(date)
            .tz(timeZoneId || Constants.DEFAULT_TIME_ZONE_ID)
            .format(`${Constants.DATE_FORMAT}, ${Constants.TIME_FORMAT}`)
          : "";
    } catch (error) {
        console.error("Error formatting date:", error, timeZoneId);
        return "";
    }
}

  static getWagerStatusDate(wagerDetail, timezone) {
    if (!_.isObject(wagerDetail) || _.isEmpty(wagerDetail)) {
      return { settled: "", accepted: "" };
    }
    const formatDate = (date) =>
      date ? this.formatDateBetDetails(date, timezone) : "";

    const settled = _.includes(
      [Constants.WAGER_STATUS.SETTLED, Constants.WAGER_STATUS.CANCELLED],
      _.get(wagerDetail, "status")
    )
      ? formatDate(_.get(wagerDetail, "settlementDate"))
      : "";

    const accepted = formatDate(_.get(wagerDetail, "wagerDate"));

    return { settled, accepted };
  }

  static getWagerStatusTest(resettleInfo, translate) {
    const isRefund = resettleInfo
      ? resettleInfo.split("-")[1] === Constants.WAGER_STATUS.REFUNDED
      : false;
    const wagerStatus = isRefund
      ? Constants.WAGER_STATUS.REFUNDED
      : resettleInfo
        ? Constants.WAGER_STATUS.RESETTLED
        : Constants.WAGER_STATUS.SETTLED;
    return translate(`mybets:${wagerStatus}`);
  }

  static convertBetAcceptanceType(inPlay, betAcceptanceType) {
    if (inPlay) {
      switch (betAcceptanceType) {
        case 1:
          return STATEMENTS.BET_ACCEPTANCE_TYPE.DANGER_ZONE;
        case 2:
          return STATEMENTS.BET_ACCEPTANCE_TYPE.LIVE_DELAY;
        default:
          return STATEMENTS.BET_ACCEPTANCE_TYPE.LIVE;
      }
    }
    return null;
  }
  
  static getWagerStatus(resettleInfo, translate) {
    const isRefund = resettleInfo
      ? resettleInfo.split("-")[1] === Constants.WAGER_STATUS.REFUNDED
      : false;
    const wagerStatus = isRefund
      ? Constants.WAGER_STATUS.REFUNDED
      : resettleInfo
        ? Constants.WAGER_STATUS.RESETTLED
        : Constants.WAGER_STATUS.SETTLED;
    return translate(`mybets:${wagerStatus}`);
  }
  
  static renderClassStatusStatement(status) {
    const formatStatus = status.toLowerCase();
    const { WIN, APPROVED, WIN_HALF, LOSS, PENDING, EXPIRED, RUNNING, CLASSNAME_LOSS, CLASSNAME_WIN, CLASSNAME_PENDING, CLASSNAME_OTHER } = STATEMENTS.STATUS
    switch (formatStatus) {
      case WIN:
      case APPROVED:
      case WIN_HALF:
        return CLASSNAME_WIN;
      case LOSS:
        return CLASSNAME_LOSS;
      case PENDING:
      case EXPIRED:
      case RUNNING:
        return CLASSNAME_PENDING;
      default:
        return CLASSNAME_OTHER;
    }
  }

  static parseBalance = (value) => {
    if (_.isNumber(value)) return value
    if (_.isString(value)) {
      const parsed = parseFloat(value.replace(/,/g, ''))
      return _.isFinite(parsed) ? parsed : 0
    }
    return 0
  }
  
  static getLanguageText = (langCode) => {
      return Utils.isPA() && langCode === LocalePath.hy_AM ? i18next.t(`lang_._${langCode}_PA`) : i18next.t(`lang_._${langCode}`)
  }

  static pushGA4RegistrationEvents = (userCode) => {
    if (!userCode) return;
      let _ga = document.cookie
        .split("; ")
        .filter((cookie) => cookie.startsWith("_ga="))[0];
      let client_id = "";
    if (_ga) {
      _ga = _ga.split(".");
      client_id = `${_ga[2]}.${_ga[3]}`;
    }
    let _gaWithId = document.cookie
      .split("; ")
      .filter((cookie) => cookie.startsWith("_ga_"))[0];
    let session_id = "";
    if (_gaWithId) {
      session_id = _gaWithId.split(".")[2].match(/s(\d+)/);
    }
    const session_id_number = session_id ? session_id[1] : null;
    window.dataLayer.push({
      event: "sign_up",
      user_id: userCode,
      client_id: client_id,
      session_id: session_id_number,
      page_location: window.location.href,
      page_referrer: document.referrer || "",
      gclid: "",
      fbclid: "",
    });
  }

  static getURLHelpLink = ({ langCode } = { langCode: "" }) => {
    const helpPageUrl = window.env.helpPageUrl || "";
    const updateLang = (url = "") => url.replace('{lang}', Utils.getHelpPageLocaleURL(langCode));
    const helpPageLanguages = Utils.convertStringToJSON(helpPageUrl) || {}

    if (!_.isEmpty(helpPageLanguages)) {
      const url = _.get(helpPageLanguages, langCode) || _.get(helpPageLanguages, 'default') || "";
      return  updateLang(url);
    }

    return updateLang(helpPageUrl);
  }
  
  static getPurposeStatusDetail = (status) => {
    const statusDetail = Constants.KYC_PURPOSE_STATUS[status]
        
    return {
	    statusClassName: statusDetail.classNames || '',
      statusName: statusDetail.label || ''
    };
  };
  
  static handleConvertFileSize = (size) => {
    const fileKB = (size / 1024).toFixed(1)
    const fileMB = (size / Constants.BYTES_PER_MB).toFixed(1)
    if (fileKB < 1024) return `${size} KB`
    return `${fileMB} MB`
  }

  static getImageLandingPage(imageNameWithExtension) {
    return `${Constants.IMAGE_LANDING_PAGE_PATH}${imageNameWithExtension}`;
  }

  static getCasinoImage(gameId, gameType, mineType, imageType) {
    return `${
      Constants.CASINO_IMAGE_PATH
    }?gameId=${gameId}&gameType=${gameType}&mineType=${mineType}&imageType=${imageType}&t=${new Date().getTime()}&locale=${Utils.getCurrentLocaleCode()}`;
  }

  static isNewLandingPage = () => {
    return window.env.isHomePageRedesignEnabled && Utils.isPA()
  }
  
}



// WEBPACK FOOTER //
// ./src/app/common/Utils.js